export * from './sgke011a.service';
export * from './sgke012a.service';
export * from './sgke021a.service';
export * from './sgke031a.service';
export * from './sgke032a.service';
export * from "./sgke041a.service";
export * from "./sgke042a.service";
export * from "./sgke043a.service";
export * from "./sgke051a.service";
export * from "./sgke052a.service";
export * from "./sgke061a.service";
export * from './sgke071a.service';
export * from './sgke072a.service';
export * from "./sgke081a.service";
export * from "./sgke082a.service";
export * from "./sgke083a.service";
export * from './sgke092a.service';
export * from './sgke094a.service';
export * from "./sgke101a.service";
export * from "./sgke102a.service";
export * from "./sgke103a.service";
export * from "./sgke111a.service";
export * from "./sgke112a.service";
export * from "./sgke113a.service";
export * from "./sgke114a.service";
export * from "./sgke115a.service";
export * from "./sgke121a.service";
export * from "./sgke122a.service";
export * from "./sgke123a.service";
export * from "./sgke124a.service";
export * from './sgke131a.service';
export * from './sgke132a.service';
export * from './sgke133a.service';
export * from './sgke141a.service';
export * from './sgke142a.service';
export * from './sgke143a.service';
export * from './sgke144a.service';
export * from './sgke145a.service';
export * from './sgke152a.service';
export * from './sgke162a.service';
export * from './sgke163a.service';
export * from './sgke164a.service';
export * from './sgke165a.service';
export * from './sgke302a.service';
export * from './sgke312a.service';
export * from './sgke313a.service';
export * from './sgke321a.service';
export * from './sgke322a.service';
export * from './sgke323a.service';
export * from './sgke331a.service';
export * from './sgke341a.service';
export * from './sgke342a.service';
export * from './sgke343a.service';
export * from "./sgke351a.service";
export * from "./sgke352a.service";
export * from "./sgke353a.service";
export * from "./sgke361a.service";
export * from "./sgke362a.service";
export * from "./sgke364a.service";
export * from "./sgke363a.service";
export * from './sgke371a.service';
export * from './sgke382a.service';
export * from './sgke383a.service';
export * from './sgke384a.service';
export * from './sgke385a.service';
export * from './sgke391a.service';
export * from './sgke401a.service';
export * from './sgke402a.service';
export * from './sgke403a.service';
export * from './sgke404a.service';
export * from './sgke411a.service';
export * from './sgke412a.service';
export * from './sgke901a.service';
export * from "./sgke902a.service";
export * from './sgke903a.service';
export * from "./szmf033a.service";

import { Sgke011aService } from './sgke011a.service';
import { Sgke012aService } from './sgke012a.service';
import { Sgke021aService } from './sgke021a.service';
import { Sgke031aService } from './sgke031a.service';
import { Sgke032aService } from './sgke032a.service';
import { Sgke041aService } from './sgke041a.service';
import { Sgke042aService } from './sgke042a.service';
import { Sgke043aService } from './sgke043a.service';
import { Sgke051aService } from './sgke051a.service';
import { Sgke052aService } from './sgke052a.service';
import { Sgke061aService } from './sgke061a.service';
import { Sgke071aService } from './sgke071a.service';
import { Sgke072aService } from './sgke072a.service';
import { Sgke081aService } from "./sgke081a.service";
import { Sgke082aService } from "./sgke082a.service";
import { Sgke083aService } from "./sgke083a.service";
import { Sgke092aService } from './sgke092a.service';
import { Sgke094aService } from './sgke094a.service';
import { Sgke101aService } from "./sgke101a.service";
import { Sgke102aService } from "./sgke102a.service";
import { Sgke103aService } from "./sgke103a.service";
import { Sgke111aService } from "./sgke111a.service";
import { Sgke112aService } from "./sgke112a.service";
import { Sgke113aService } from "./sgke113a.service";
import { Sgke114aService } from "./sgke114a.service";
import { Sgke115aService } from "./sgke115a.service";
import { Sgke121aService } from "./sgke121a.service";
import { Sgke122aService } from "./sgke122a.service";
import { Sgke123aService } from "./sgke123a.service";
import { Sgke124aService } from "./sgke124a.service";
import { Sgke131aService } from './sgke131a.service';
import { Sgke132aService } from './sgke132a.service';
import { Sgke133aService } from './sgke133a.service';
import { Sgke141aService } from './sgke141a.service';
import { Sgke142aService } from './sgke142a.service';
import { Sgke143aService } from './sgke143a.service';
import { Sgke144aService } from './sgke144a.service';
import { Sgke145aService } from './sgke145a.service';
import { SGKE152AService } from './sgke152a.service';
import { Sgke162aService } from './sgke162a.service';
import { Sgke163aService } from './sgke163a.service';
import { Sgke164aService } from './sgke164a.service';
import { Sgke165aService } from './sgke165a.service';
import { Sgke302aService } from './sgke302a.service';
import { Sgke312aService } from './sgke312a.service';
import { Sgke313aService } from './sgke313a.service';
import { Sgke321aService } from './sgke321a.service';
import { Sgke322aService } from './sgke322a.service';
import { Sgke323aService } from './sgke323a.service';
import { Sgke331aService } from './sgke331a.service';
import { Sgke341aService } from './sgke341a.service';
import { Sgke342aService } from './sgke342a.service';
import { Sgke343aService } from './sgke343a.service';
import { Sgke351aService } from "./sgke351a.service";
import { Sgke352aService } from "./sgke352a.service";
import { Sgke353aService } from "./sgke353a.service";
import { Sgke361aService } from "./sgke361a.service";
import { Sgke362aService } from "./sgke362a.service";
import { Sgke363aService } from "./sgke363a.service";
import { Sgke364aService } from "./sgke364a.service";
import { Sgke371aService } from './sgke371a.service';
import { Sgke382aService } from './sgke382a.service';
import { Sgke383aService } from './sgke383a.service';
import { Sgke384aService } from './sgke384a.service';
import { Sgke385aService } from './sgke385a.service';
import { Sgke391aService } from './sgke391a.service';
import { Sgke401aService } from './sgke401a.service';
import { Sgke402aService } from './sgke402a.service';
import { Sgke403aService } from './sgke403a.service';
import { Sgke404aService } from './sgke404a.service';
import { Sgke411aService } from './sgke411a.service';
import { Sgke412aService } from './sgke412a.service';
import { Sgke901aService } from './sgke901a.service';
import { Sgke902aService } from "./sgke902a.service";
import { Sgke903aService } from './sgke903a.service';
import { Szmf033aService } from './szmf033a.service';


export const APIS_SGKE = [
    Sgke011aService,
    Sgke012aService,
    Sgke021aService,
    Sgke031aService,
    Sgke032aService,
    Sgke041aService,
    Sgke042aService,
    Sgke043aService,
    Sgke051aService,
    Sgke052aService,
    Sgke061aService,
    Sgke071aService,
    Sgke072aService,
    Sgke081aService,
    Sgke082aService,
    Sgke083aService,
    Sgke092aService,
    Sgke094aService,
    Sgke101aService,
    Sgke102aService,
    Sgke103aService,
    Sgke111aService,
    Sgke112aService,
    Sgke113aService,
    Sgke114aService,
    Sgke115aService,
    Sgke121aService,
    Sgke122aService,
    Sgke123aService,
    Sgke124aService,
    Sgke131aService,
    Sgke132aService,
    Sgke133aService,
    Sgke141aService,
    Sgke142aService,
    Sgke143aService,
    Sgke144aService,
    Sgke145aService,
    Sgke162aService,
    Sgke163aService,
    Sgke164aService,
    Sgke165aService,
    SGKE152AService,
    Sgke302aService,
    Sgke312aService,
    Sgke313aService,
    Sgke321aService,
    Sgke322aService,
    Sgke323aService,
    Sgke331aService,
    Sgke341aService,
    Sgke342aService,
    Sgke343aService,
    Sgke351aService,
    Sgke352aService,
    Sgke353aService,
    Sgke361aService,
    Sgke362aService,
    Sgke363aService,
    Sgke364aService,
    Sgke371aService,
    Sgke382aService,
    Sgke383aService,
    Sgke384aService,
    Sgke385aService,
    Sgke391aService,
    Sgke401aService,
    Sgke402aService,
    Sgke403aService,
    Sgke404aService,
    Sgke411aService,
    Sgke412aService,
    Sgke901aService,
    Sgke902aService,
    Sgke903aService,
    Szmf033aService,
];
